var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-checkbox ml-2"},[_c('label',[_c('input',{staticClass:"mr-3",attrs:{"disabled":_vm.disabled,"type":"checkbox","name":"checkbox"},domProps:{"checked":_vm.checked},on:{"change":_vm.handleChange}}),_vm._v(_vm._s(_vm.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }